import * as React from 'react'

const usePassiveLayoutEffect =
  React[
    typeof document !== 'undefined' && document.createElement !== void 0
      ? 'useLayoutEffect'
      : 'useEffect'
  ]

export default usePassiveLayoutEffect
